import { Button } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { t } from "i18next";
import { useStores } from "../../../shared/stores/RootStore";
import { CustomDialog } from "../../../shared/views/CustomDialog";

const NodeRefreshAlertBase: React.FC = () => {
  const { osaNodeStore } = useStores();

  if (!osaNodeStore.showNodeRefreshAlert) return null;

  const refreshNodes = async () => {
    osaNodeStore.closeNodeRefreshAlert();

    for (const osaWayId of osaNodeStore.nodesByWayId.keys()) {
      await osaNodeStore.fetchNodes(osaWayId);
    }
  };

  return (
    <CustomDialog
      size="md"
      onClose={osaNodeStore.closeNodeRefreshAlert}
      header={t("shared:nodeRefreshAlert.title")}
      footer={
        <Button colorPalette="primary" onClick={refreshNodes}>
          {t("shared:nodeRefreshAlert.action")}
        </Button>
      }
    >
      {t("shared:nodeRefreshAlert.description")}
    </CustomDialog>
  );
};

export const NodeRefreshAlert = observer(NodeRefreshAlertBase);
